<template>

    <div class="">
        <label for="group_id" class="form-label">
            <strong>
                Group
            </strong>
        </label>

        <v-select
            v-model="selectedGroup"
            :options="groups"
            label="name"
            :clearable="false"
            placeholder="Select a Group"
            required
            :disabled="groups.length <= 1"
        />

        <input type="hidden" name="group_id" :value="selectedGroup ? selectedGroup.id : ''">

        <div v-if="errors.length > 0" >
            <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
                {{ error }}
            </div>
        </div>

    </div>

</template>

<script>

import VSelect from 'vue-select';

export default {

    props: {
        user: {
            type: Object,
            required: false,
            default: null
        },
        groups: {
            type: Array,
            required: true,
        },
        old: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            required: false
        },
    },

    components: {
        VSelect
    },

    data() {
        return {
            selectedGroup: {},
        }
    },

    mounted() {
        if (this.groups.length === 1) {
            this.selectedGroup = this.groups[0];
        } else if (this.user && this.user.group_id) {
            this.selectedGroup = this.groups.find(group => group.id === this.user.group_id);
        } else if (this.old) {
            this.selectedGroup = this.groups.find(group => group.id === parseInt(this.old));
        } else if (this.groups.length > 0) {
            this.selectedGroup = this.groups[0];
        }
    },

}

</script>
